module.exports = __webpack_public_path__ + "img/logo_jinyao.c3e309fe.png";